import { CanvasBlockRenderer } from "../CanvasBlockRenderer";
import { type CanvasBlock } from "../types";

interface ListBlockProps {
  ordered: boolean;
  items: CanvasBlock[];
}

export function ListBlock({ ordered, items }: ListBlockProps) {
  const Tag = ordered ? "ol" : "ul";
  const listClass = ordered ? "list-decimal" : "list-disc";

  return (
    <Tag
      className={`${listClass} space-y-1 pl-5 text-sm text-puntt-neutral-gray-11`}
    >
      {(items ?? []).map((item, idx) => (
        <li key={idx}>
          <CanvasBlockRenderer block={item} />
        </li>
      ))}
    </Tag>
  );
}
